module.exports = __webpack_public_path__ + "static/img/Q_pikes.c0ff7a9.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/cards/Q_pikes.svg
// module id = uVyc
// module chunks = 1